import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { Container, Typography, Grid, CircularProgress } from '@mui/material';

import MyAppBar from '../components/MyAppBar';
import PermitDetails from '../components/PermitDetails';

const styles = {
  title: {
    // paddingTop: 15,
    paddingTop: 1.5,
    // paddingLeft: 30,
    paddingLeft: 3,
  },
  container: {
    padding: 0,
    backgroundColor: '#eeeeee',
  },
};

// class Permit extends React.Component {
export default function Permit(props) {
  // state = {
  //   permits: [],
  //   loading: false,
  // };
  const location = useLocation();
  const [permits, setPermits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [permittee, setPermittee] = useState('');

  useEffect(() => {
    console.log('Permit params:');
    const params = queryString.parse(location.search);
    console.log(params);
    setLoading(true);
    setPermittee(params.permittee);
    setYear(params.year);
    setMonth(params.month);
    getPermit(params.permits);
  }, []);

  // componentDidMount() {
  //   const { permits, permittee, year, month } = queryString.parse(
  //     this.props.location.search
  //   );
  //   this.setState({
  //     permittee,
  //     year,
  //     month,
  //     loading: true,
  //   });
  //   this.getPermit(permits);
  // }

  const getPermit = async (permitNumbers) => {
    console.log('getting permits');
    const { apiUrl } = window['config'];
    const response = await fetch(`${apiUrl}/permit/${permitNumbers}`);
    const permits = await response.json();
    setPermits(permits);
    setLoading(false);
    // this.setState({
    //   permits,
    //   loading: false,
    // });
  };

  return (
    <React.Fragment>
      <MyAppBar title='Permit Recommendations' />
      <Container sx={styles.container}>
        <Typography variant='h3' sx={styles.title}>
          {permittee}
        </Typography>
        <Grid>
          {loading && <CircularProgress />}
          {permits.map((permit) => (
            <PermitDetails
              key={permit.CA_OBJECT_ID}
              permit={permit}
              year={year}
              month={month}
            />
          ))}
        </Grid>
      </Container>
    </React.Fragment>
  );
}
